import menuApi from "../api/menu-api";

const add = async (payload) => {
    const resp = await menuApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    // console.log('edit ', payload);
    const resp = await menuApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    // console.log(' edit menu ', resp);
    return resp;
}

const remove = async (payload) => {
    const resp = await menuApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition) => {
	try {
		const result = await menuApi.search(condition);
		return result;
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const menuService = {
    add,
    edit,
    remove,
    search
};

export default menuService;